// extracted by mini-css-extract-plugin
export default {"container":"portfolioIndustry_container__UdJoM"};